import topic from '../topic'
export const adminAPI = {
    adminLogin: topic.adminTopic + '/login', //管理员登录
    getAllAccounts: topic.adminTopic + '/get_all_accounts', //获取所有FCP用户账号
    editAccountsStatus: topic.adminTopic + '/edit_accounts_status', //批量修改FCP账号状态
    getAccounts: topic.adminTopic + '/get_accounts', //根据条件筛选用户
}